export const appUris = {
	ADMIN_CONSENT: "/adminConsent",
	TEAMS: "/teams/",
	TEAMS_ADMIN_CONSENT: "/teams/adminConsent",
	TEAMS_USER_CONSENT: "/teams/userConsent"
};
